var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuestionMarkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E67D2D",
  d: "m10.456 7.4-.72.736C9.16 8.712 8.8 9.2 8.8 10.4H7.2V10c0-.888.36-1.688.936-2.264l.992-1.008C9.424 6.44 9.6 6.04 9.6 5.6a1.6 1.6 0 1 0-3.2 0H4.8a3.2 3.2 0 1 1 6.4 0 2.56 2.56 0 0 1-.744 1.8ZM8.8 13.6H7.2V12h1.6M8 0a8 8 0 1 0 8 8c0-4.424-3.6-8-8-8Z"
})));
export { SvgQuestionMarkIcon as ReactComponent };
export default __webpack_public_path__ + "17d3b2dc71044531126e8c3e8b93a458.svg";